import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,

  state: () => ({
    courses: [], // student registered courses
    combination: {
      // sample
      code: "",
      courses: [] // lenght 4 (courses) [1,2,3,4]
    }, // student course combination
    subscriptions: []
  }),

  mutations: {
    courses(state, courses) {
      state.courses = courses || [];
    },

    combination(state, combination) {
      state.combination = combination || {
        code: "",
        courses: []
      };
    },

    subscriptions(state, subscriptions) {
      state.subscriptions = subscriptions || [];
    }
  },

  actions: {
    async getSubscriptions({ commit, rootState }) {
      const userId = rootState.auth.user.id;
      return axios
        .get("/students/" + userId + "/subscriptions")
        .then(response => {
          commit("subscriptions", response.data.subscriptions);
          return response;
        });
    },

    async getCourseCombination({ commit, rootState }) {
      const userId = rootState.auth.user.id;
      return axios
        .get("/students/" + userId + "/courses/combination")
        .then(response => {
          commit("combination", response.data.combination);
          return response;
        });
    },

    async updateCourseCombination({ commit, rootState }, data) {
      return axios
        .post(
          "/students/" + rootState.auth.user.id + "/courses/combination",
          data
        )
        .then(response => {
          commit("combination", response.data.course_combination);
          return response;
        });
    }
    // getStudentCourses({commit}, studentId){
    //   axios.get("/student/"+ studentId +"/courses")
    // .then(response => {commit("courses", response.data.courses)})
    // }
  },

  getters: {
    hasCombination: state => {
      const course_combination = state.combination;
      if (course_combination !== {}) {
        const combination = course_combination.courses || [];
        return combination.length == 4;
      }
      return false;
    },

    combinationCourses: (state, getter, rootState) => {
      const courses_ids = state.combination.courses;
      const courses = rootState.course.courses.filter(c => {
        return courses_ids.includes(c.id);
      });
      return courses || [];
    },

    activeSubscriptions: state => {
      return state.subscriptions.filter(subscription => {
        const end_at = moment(subscription.pivot.end_at);
        return moment().isBefore(end_at);
      });
    }
  },

  modules: {}
};
